"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M17.74,14.3a3.44,3.44,0,0,0-2.89,1.57L9.49,13.19a3.41,3.41,0,0,0,0-2.38l5.36-2.68a3.48,3.48,0,1,0-.34-.69L9.14,10.13a3.44,3.44,0,1,0,0,3.74l5.37,2.68a3.44,3.44,0,1,0,3.23-2.26Z"
  }));
};

exports["default"] = _default;